import { Box } from "@similarweb/ui-components/foundations";

import { swSettings } from "app/common/services/swSettings";
import { isTrial } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

import { LowCreditsBanner } from "../../components/LowCreditsBanner/LowCreditsBanner";
import { AI_AGENT_MAX_OPTION_VALUE, AI_AGENT_PRICE_PER_RECORD } from "../../constants";
import { useCompanyQuota } from "../../hooks/useCompanyQuota";
import { useLowCreditsBannerVisibility } from "../../hooks/useLowCreditsBannerVisibility";
import { useLowQuotaBannerManagement } from "../../hooks/useLowQuotaBannerManagement";
import { useQuotaGuard } from "../../hooks/useQuotaGuard";

export const LowQuotaBannerContainer = ({
    variant = "prominent",
    isInline = false,
}: {
    variant?: "compact" | "prominent" | "prominentCompact";
    isInline?: boolean;
}) => {
    const { isEnabled, isLoading, quota } = useQuotaGuard(AI_AGENT_PRICE_PER_RECORD);
    const { lowCreditsBannerConfigs } = useLowQuotaBannerManagement();
    const { data: companyQuota, isQuotaReached: isCompanyQuotaReached } = useCompanyQuota();

    const isVisibleByExportQuota = useLowCreditsBannerVisibility({
        totalQuota: quota?.total ?? 0,
        remainingQuota: quota?.remaining ?? 0,
        pricePerRecord: AI_AGENT_PRICE_PER_RECORD,
        maxOptionValue: AI_AGENT_MAX_OPTION_VALUE,
    });

    // Trial users don't have a separate "export" data-credits quota — their gating
    // signal is the company-information quota exposed by `useCompanyQuota`. Surface
    // the same banner once they've exhausted it so the trial CTA is reachable from
    // AI-agent / super-agent surfaces.
    const isTrialAndNoCredits = isTrial(swSettings) && Boolean(companyQuota) && isCompanyQuotaReached;

    const showBanner = (isVisibleByExportQuota && isEnabled && !isLoading) || isTrialAndNoCredits;

    if (!showBanner) {
        return null;
    }

    return (
        <Box
            margin={!isInline ? "16px 0" : ""}
            width="100%"
        >
            <LowCreditsBanner
                {...lowCreditsBannerConfigs}
                variant={variant}
                isInline={isInline}
            />
        </Box>
    );
};
